<template>
  <!-- footer start -->
  <footer class="rodape">
    <div class>
      <div class="white-bg text-center pt-3 pb-3">
        <p class="textorodape">Copyright LEFISC - Legislação Fiscal - Todos os Direitos Reservados</p>
      </div>
    </div>
  </footer>
  <!-- footer end -->
</template>

<script>
export default {};
</script>

<style scoped>
.rodape {
  text-align: center;
  width: 100%;
  padding-top: 5px;
  margin: 30px 0 0 0;
}

.textorodape {
  color: #212529;
  font-size: 16px;
}

p {
  margin: 0;
}

@media (max-width: 425px) {
  .textorodape {
    font-size: 12px;
  }
}
@media (max-width: 320px) {
  .textorodape {
    font-size: 10px;
  }
}
</style>